import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MaintenanceDialog from '../Dialogs/MaintenanceDialog'
import ProtectByFeatures from '../Security/ProtectByFeatures'
import { Footer, Root } from './BrandLayout.styles'

/**
 * The BrandLayout's component.
 */
const BrandLayout = props => {
  const { children, footer } = props
  const [dialogClosed, setDialogClosed] = useState(false)

  return (
    <Root>
      <ProtectByFeatures rule={features => features['cl.chilecompra.datos-abiertos/marquee']}>
        {!dialogClosed ? <MaintenanceDialog close={dialogClosed => setDialogClosed(dialogClosed)} /> : null}
      </ProtectByFeatures>
      {children}
      {footer && <Footer>{footer}</Footer>}
    </Root>
  )
}

BrandLayout.defaultProps = {
  featured: null,
  footer: null
}
BrandLayout.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node
}

export default BrandLayout
